import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { OTHER_COMPETITOR_ID } from '../constants'

interface ICalculateOtherSob {
  competitors: ISobCompetitor[]
  field: string
  entryId: string
}
export const calculateOtherSob = ({ competitors, field, entryId }: ICalculateOtherSob): number => {
  const allCompetitors = competitors.filter(
    (el) => el.EntryId === entryId && el.CompetitorID !== OTHER_COMPETITOR_ID
  )
  return 100 - allCompetitors.reduce((acc, comp) => acc + comp[field], 0)
}
